<div *ngIf="isLoading">
  <div *appSpinner="isLoading; message: 'Loading...'"></div>
</div>
<div *ngIf="isAdding">
  <div *appSpinner="isAdding; message: 'Please wait...'"></div>
</div>
<div *ngIf="customer && !isLoading" class="container">
  <div class="sticky_customer">
    <p translate>{{ 'customer.customer' | translate:{name: customer.name} }}</p>
    <p translate [translateParams]="{credit: customer.credits ? customer.credits : 0 }">customer.creditInfo</p>
    <div class="d-flex" style="gap: 6px">
      <span translate>customer.premiumCredits</span>
      <span>{{customer.premiumCredits || 0}}</span>
    </div>
  </div>
  <hr>
  <div *ngIf="customer && customer?.allowChilds">
    <p style="font-size: 1.4rem" translate>customer.subCustomers</p>
    <div *ngIf="subcustomers && !subcustomers.length" class="text-center p-3">
      <p translate>customer.noSubcustomers</p>
      <button class="custom-button" (click)="openAddCustomerModal()" translate>customer.addNewSubcustomer</button>
    </div>
    <div *ngIf="subcustomers && subcustomers.length">
      <div class="card-header all-app">
        <div class="d-flex align-items-center flex-row justify-content-end">
          <button type="button" class="custom-button add-button" (click)="openAddCustomerModal()"
            translate>customer.addSubcustomers<i class="fa fa-plus" style="margin-left: 7px;"></i>
          </button>
        </div>
      </div>
      <div>
        <div class="row">
          <!-- | userFilter:searchParam beside | paginate -->
          <app-customer-card class="customer col-lg-4 col-md-6 col-sm-12" [customer]="customer"
            [customerId]="customerId" [showChangePassword]="false" (reloadEditCustomerOut)="reloadEditCustomer($event)"
            (reloadDeleteCustomerOut)="reloadDeleteCustomer($event)"
            (reloadCustomers)="reloadCustomer($event)"
            *ngFor="let customer of subcustomers | slice: (customerPage-1) * customerPerPage : (customerPage-1) * customerPerPage + customerPerPage"></app-customer-card>
          <!-- /.widget-user -->
        </div>
        <div class="clearfix w-100"></div>
        <ngb-pagination *ngIf="subcustomers && subcustomers.length" [collectionSize]="subcustomers.length"
          [(pageSize)]="customerPerPage" [(page)]="customerPage" [maxSize]="5" [rotate]="true"
          (pageChange)="jumpToCustomersPage($event)"></ngb-pagination>
      </div>
      <!-- /.card-body -->
    </div>
    <hr>
  </div>

  <!-- presets -->
  <app-profile-presets-list *ngIf="canSeeAdmins" (addItem)="addPreset($event)" (deletePresetItem)="deletePreset($event)"
    [secondProfilesOnThePage]='false' [title]="'customer.customerPresets'"
    [noDataMsg]="'customer.customerNoAssignedPresets'"></app-profile-presets-list>

  <!-- frames -->
  <app-frames-list *ngIf="canSeeAdmins" [role]="'customer'" [customerId]="customerId"></app-frames-list>

  <app-license-plates-list *ngIf="canSeeAdmins" [role]="'customer'" [customerId]="customerId"></app-license-plates-list>

  <app-logos-list *ngIf="canSeeAdmins" [role]="'customer'" [customerId]="customerId"></app-logos-list>

  <app-profile-backgrounds-list *ngIf="canSeeAdmins" (addItem)="addBackground($event)"
    (deleteBgFile)="deleteBackground($event)" [secondProfilesOnThePage]="false"></app-profile-backgrounds-list>
  <!-- CUSTOMER & CLIENT FEATURES -->
  <div *ngIf="canSeeAdmins" class="col-lg-12 col-md-12 col-sm-12 card">
    <div class="card-header">
      <h3 *ngIf="currentUser.role.name === 'root'" class="card-title" translate>Features Custom Price</h3>
      <h3 *ngIf="currentUser.role.name !== 'root'" class="card-title" translate>settings.featuresPrice</h3>
      <button *ngIf="currentUser.role.name === 'root'" type="button" class="custom-button add-button"
        style="float: right;" (click)="toggleFeaturePrice = true">New Feature Price<i class="fa fa-plus"
          style="margin-left: 7px;"></i></button>
    </div>
    <div style="padding: 0.75rem 1.25rem;">
      <div *ngIf="customerFeatures && !customerFeatures.length" style="min-height: 60px;">
        <p class="no-data-message" translate>No features.</p>
      </div>
      <p *ngIf="customerFeatures && customerFeatures.length">
        <button class="custom-button btn-red" type="button" data-toggle="collapse" data-target="#collapseExample"
          aria-expanded="false" aria-controls="collapseExample" translate>settings.seePrices</button>
      </p>
      <div class="collapse price_container" id="collapseExample">
        <div class="d-flex justify-content-between my-2 px-2 feature_price"
          *ngFor="let feature of customerFeatures; let index = index">
          <p *ngIf="currentUser.role.name === 'root'" style="flex: 1">{{feature.feature?.displayName}}</p>
          <p *ngIf="currentUser.role.name !== 'root'" style="flex: 1">{{feature?.displayName}}</p>
          <p style="flex: 1" class="text-center">Price: {{feature.price}}</p>
          <div *ngIf="currentUser.role.name === 'root'" style="flex: 1" class="edit-webhook">
            <button class="edit-button" (click)="onEditPrice(feature)" translate>global.edit</button>
            <button class="delete-button" (click)="deletePrice(feature)" translate>global.delete</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-general-settings-item *ngIf="['root'].includes(currentUser.role.name)" [icon]="" [title]="'Shadow Type'"
    [userChecks]="true">
    <app-general-settings-select mySelect [disabled]="currentUser.role.name !== 'root'" [currentUser]='currentUser'
      [defaultSelect]='customer.shadowType' [options]='shadowType' (select)='changeLegacyChadow($event)'>
    </app-general-settings-select>
  </app-general-settings-item>
  <app-general-settings-item *ngIf="currentUser.role.name === 'root'" [icon]="" [title]="'Use Premium'"
    [userChecks]="true" [isNew]="true" [newUntil]="'2026-03-01'">
    <app-general-settings-checkbox mySelect [defaultChecked]='customer?.usePremium'
      (select)="updateSetting($event, 'usePremium')" [userCheck]="true"></app-general-settings-checkbox>
  </app-general-settings-item>
  <app-general-settings-item *ngIf="currentUser.role.name === 'root'" [icon]="" [title]="'Remove Reflections'"
    [userChecks]="true">
    <app-general-settings-checkbox mySelect [defaultChecked]='customer?.removeReflectionsEnabled'
      (select)="switchRemoveReflections($event)" [userCheck]="true"></app-general-settings-checkbox>
  </app-general-settings-item>
  <app-general-settings-item *ngIf="currentUser.role.name === 'root'" [icon]="" [title]="'Vin Decode'"
    [userChecks]="true">
    <app-general-settings-checkbox mySelect [defaultChecked]='customer?.automaticVinDecodeEnabled'
      (select)="switchVinDecode($event)" [userCheck]="true"></app-general-settings-checkbox>
  </app-general-settings-item>
  <app-general-settings-item *ngIf="currentUser.role.name === 'root'" [icon]="" [title]="'Geolocation'"
    [userChecks]="true">
    <app-general-settings-checkbox mySelect [defaultChecked]='customer?.geoLocationEnabled'
      (select)="switchGeoLocation($event)" [userCheck]="true"></app-general-settings-checkbox>
  </app-general-settings-item>
  <app-general-settings-item *ngIf="currentUser.role.name === 'root'" [icon]="" [title]="'Gif'" [userChecks]="true">
    <app-general-settings-checkbox mySelect [defaultChecked]='customer?.createGifEnabled' (select)="updateSetting($event, 'createGifEnabled')"
      [userCheck]="true" (notifyF)="conflictNotify('createGifEnabled')" [disabled]="customer?.threeSixtyVideo"></app-general-settings-checkbox>
  </app-general-settings-item>
  <app-general-settings-item *ngIf="currentUser.role.name === 'root'" [icon]="" [title]="'MP4'" [userChecks]="true">
    <app-general-settings-checkbox mySelect [defaultChecked]='customer?.threeSixtyVideo' (select)="updateSetting($event, 'threeSixtyVideo')"
      [userCheck]="true" (notifyF)="conflictNotify('threeSixtyVideo')" [disabled]="customer?.createGifEnabled"></app-general-settings-checkbox>
  </app-general-settings-item>

  <app-general-settings-item *ngIf="currentUser.role.name === 'root'" [icon]="" [title]="'Duplicate car'"
    [userChecks]="true">
    <app-general-settings-checkbox mySelect [defaultChecked]='customer?.duplicateVehicleEnabled'
      (select)="switchDuplicateCar($event)" [userCheck]="true"></app-general-settings-checkbox>
  </app-general-settings-item>

  <div *ngIf="['root'].includes(currentUser.role.name)"
    class="d-flex justify-content-between mb-3 settings-item bg-white border-bottom">
    <div class="w-100 d-flex align-items-center">
      <h3>Guideline link</h3>
    </div>
    <div class="choose-window" style="width: 300px;">
      <input type="text" class="form-control" placeholder="Guideline link" name="customer?.guidelineLink" [(ngModel)]="customer.guidelineLink">
      <button class="custom-button ml-3" (click)="guidelineLink()">SAVE</button>
    </div>
  </div>

  <app-general-settings-item *ngIf="currentUser.role.name === 'root'" [icon]="" [title]="'Panorama'"
    [userChecks]="true">
    <app-general-settings-checkbox mySelect [defaultChecked]='customer?.panoramaEnabled'
      (select)="updateSetting($event, 'panoramaEnabled')" [userCheck]="true"></app-general-settings-checkbox>
  </app-general-settings-item>

  <app-general-settings-item *ngIf="currentUser.role.name === 'root'" [icon]="" [title]="'Markers'"
    [userChecks]="true">
    <app-general-settings-checkbox mySelect [defaultChecked]='customer?.markersEnabled'
      (select)="updateSetting($event, 'markersEnabled')" [userCheck]="true"></app-general-settings-checkbox>
  </app-general-settings-item>

  <app-general-settings-item *ngIf="currentUser.role.name === 'root'" [title]="'Deactivate Account'"
    [userChecks]="true">
    <app-general-settings-checkbox mySelect [defaultChecked]='customer?.deactiveAccountEnabled'
      (select)="updateSetting($event, 'deactiveAccountEnabled')" [userCheck]="true">
    </app-general-settings-checkbox>
  </app-general-settings-item>

  <app-general-settings-item *ngIf="isInteriorBgVisible" [title]="'settings.interiorBg'"
    [userChecks]="true">
    <app-general-settings-checkbox mySelect [defaultChecked]='customer?.interiorBackgroundEnabled'
      (select)="updateSetting($event, 'interiorBackgroundEnabled')" [userCheck]="true">
    </app-general-settings-checkbox>
  </app-general-settings-item>

  <app-general-settings-item *ngIf="isFillableImageVisible" [icon]="" [title]="'Fillable Image'"
    [userChecks]="true">
    <app-general-settings-checkbox mySelect [defaultChecked]='customer?.fillableImageEnabled'
      (select)="updateSetting($event, 'fillableImageEnabled')" [userCheck]="true"></app-general-settings-checkbox>
  </app-general-settings-item>

  <app-general-settings-item *ngIf="isPreprocessingVisible" [icon]="" [title]="'Preprocessing'"
    [userChecks]="true">
    <app-general-settings-checkbox mySelect [defaultChecked]='customer?.preprocessingEnabled'
      (select)="updateSetting($event, 'preprocessingEnabled')" [userCheck]="true"></app-general-settings-checkbox>
  </app-general-settings-item>

  <app-general-settings-item *ngIf="isCrossClientSearchControl" [icon]="" [title]="'Cross Client Search Control'"
    [userChecks]="true">
    <app-general-settings-checkbox mySelect [defaultChecked]='customer?.crossClientSearchControlEnabled'
      (select)="updateSetting($event, 'crossClientSearchControlEnabled')" [userCheck]="true"></app-general-settings-checkbox>
  </app-general-settings-item>

  <app-general-settings-item *ngIf="isCrossClientSearch" [icon]="" [title]="'Cross Client Search'"
    [userChecks]="true">
    <app-general-settings-checkbox mySelect [defaultChecked]='customer?.crossClientSearchEnabled'
      (select)="updateSetting($event, 'crossClientSearchEnabled')" [userCheck]="true"></app-general-settings-checkbox>
  </app-general-settings-item>

  <app-general-settings-item *ngIf="licensePlateNumberEnabled" [icon]="" [title]="'License Plate Enabled'"
    [userChecks]="true">
    <app-general-settings-checkbox mySelect [defaultChecked]='customer?.licensePlateNumberEnabled'
      (select)="updateSetting($event, 'licensePlateNumberEnabled')" [userCheck]="true"></app-general-settings-checkbox>
  </app-general-settings-item>

  <div *ngIf="['root'].includes(currentUser.role.name)"
    class="d-flex justify-content-between mb-3 settings-item bg-white border-bottom">
    <div class="w-100 d-flex align-items-center">
      <h3>Glass Blur Coefficient</h3>
    </div>
    <div class="choose-window" style="width: 300px;">
      <input type="text" class="form-control" placeholder="Glass Blur Coefficient" name="customer?.glassBlurCoefficient" [(ngModel)]="customer.glassBlurCoefficient">
      <button class="custom-button ml-3" (click)="updateCustomer('glassBlurCoefficient', customer.glassBlurCoefficient)">SAVE</button>
    </div>
  </div>

  <p style="font-size: 1.4rem" translate>customer.admins</p>
  <div *ngIf="admins && !admins.results.length" translate>
    <p translate>customer.noAdmins</p>
    <button class="custom-button" (click)="toggleAddAdmin = true" translate>customer.newAdmin</button>
  </div>
  <!-- <div>
    <button class="custom-button" (click)="toggleAddAdmin = true">Add new</button>
  </div> -->
  <div *ngIf="admins && admins.results.length">
    <div class="card-header all-app">
      <div class="d-flex align-items-center flex-row justify-content-end">
        <button type="button" class="custom-button add-button" (click)="toggleAddAdmin = true;"
          translate>customer.addNewAdmin<i class="fa fa-plus" style="margin-left: 7px;"></i>
        </button>
      </div>
    </div>
    <div>
      <div class="row">
        <!-- | userFilter:searchParam beside | paginate -->
        <div class="customer col-lg-4 col-md-6 col-sm-12" *ngFor="let admin of admins.results">
          <div class="card card-widget widget-user">
            <!-- Add the bg color to the header using any of the bg-* classes -->
            <div class="widget-user-header bg-info-active">
              <h3 style="font-size: 1.3rem;" class="widget-user-username">{{admin.name}}</h3>
              <h6 class="widget-user-desc">{{admin.email}}</h6>
              <span class="button-edit" style="right: 0;" (click)="showDialogEditAdmin(dialogEditAdmin, admin)"
                translate>global.edit<i class="fa fa-pencil-square center ml-1" aria-hidden="true"></i>
              </span>
            </div>
            <div class="widget-user-image">
              <img class="img-circle elevation-2" src="/assets/img/catcher.png" alt="User Avatar">
            </div>
            <div class="card-footer">

            </div>
          </div>
          <!-- /.widget-user -->

        </div>
      </div>
      <ngb-pagination *ngIf="admins && admins.results.length"
      [collectionSize]="admins.count" [(pageSize)]="customerAdminPerPage" [(page)]="customerAdminPage" [maxSize]="5"
      [rotate]="true" (pageChange)="jumpToCustomerAdminPage($event)"></ngb-pagination>
      <div class="clearfix" style="width: 100%"></div>
    </div>
    <!-- /.card-body -->
  </div>

  <div *ngIf="currentUser.role.name === 'root' || customer.parentId">
    <app-subcustomer-users [loadData]="eventsSubject.asObservable()"
      [removeReflections]="removeReflectionSubject.asObservable()" (credit)="setCredit($event)"
      [customer]="customer"></app-subcustomer-users>
  </div>
</div>

<app-add-customer #dialogAddCustomer (addCustomer)="sendCustomer($event)" [subcustomer]="true"></app-add-customer>

<!-- NEEDED FOR CUSTOMER USER CREATE -->

<app-modal (close)="toggleAddAdmin = false;" *ngIf="toggleAddAdmin">
  <div class="modal_container black-text">
    <p class="text-header-modal" translate>customer.newAdmin</p>
    <div class="modal-body">
      <form #adminForm="ngForm" (ngSubmit)="addAdmin(adminForm)" class="form-vehicle">

        <div class="form-group">
          <label translate>customer.fullName</label>
          <input type="text" #name="ngModel" autocomplete="off" required ngModel class="form-control"
            [class.is-invalid]="name.invalid && name.touched" name="name">
        </div>

        <div class="form-group">
          <label translate>customer.email</label>
          <input type="email" #email="ngModel" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
            autocomplete="off" required ngModel class="form-control" [class.is-invalid]="email.invalid && email.touched"
            name="email">
        </div>

        <div class="form-group">
          <label translate>customer.password</label>
          <input type="password" #password="ngModel" autocomplete="off" required ngModel class="form-control"
            [class.is-invalid]="password.invalid && password.touched" name="password">
        </div>

        <div class="form-group">
          <label translate>customer.repeatPassword</label>
          <input type="password" #passwordRepeat="ngModel" autocomplete="off" required ngModel class="form-control"
            [class.is-invalid]="passwordRepeat.invalid && passwordRepeat.touched" name="passwordRepeat">
        </div>

        <div class="form-group">
          <label translate>global.phone</label>
          <input type="text" appAllownumbersonly #phone="ngModel" autocomplete="off" ngModel class="form-control"
            name="phone">
        </div>

        <div *ngIf="currentUser.role.name === 'root'" class="d-flex justify-content-between mb-4 align-items-center">
          <div class="w-100">
            <p>Is Manager ?</p>
          </div>
          <div style="position: relative;" class="row">
            <div class="choose-window">
              <p>Off</p>
              <label class="switch">
                <input type="checkbox" name="readOnlyPermissions" ngModel>
                <span class="slider round"></span>
              </label>
              <p>ON</p>
            </div>
          </div>
        </div>

        <button type="submit" class="custom-button" style="width: 120px;" translate>global.save</button>
      </form>
    </div>
  </div>
</app-modal>

<!-- Modal Form EDIT Admin -->
<ng-template #dialogEditAdmin let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" translate>customer.editAdmin</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #editAdminForm="ngForm" (ngSubmit)="sendEditAdmin(editAdminForm)" class="form-vehicle">
      <!-- Full name -->
      <div class="row">
        <div class="input-group mb-3 col-lg-12 col-md-12 col-sm-12">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon3" translate>customer.fullName</span>
          </div>
          <input type="text" autocomplete="off" class="form-control" id="name" name="name" required
            [ngModel]="editAdmin.name">
        </div>
      </div>
      <!-- Email -->
      <div class="row">
        <div class="input-group mb-3 col-lg-12 col-md-12 col-sm-12">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon3" translate>customer.email</span>
          </div>
          <input type="email" autocomplete="off" class="form-control" id="email" name="email" required
            [ngModel]="editAdmin.email">
        </div>
      </div>
      <div *ngIf="currentUser.role.name === 'root'" class="d-flex justify-content-between mb-4 align-items-center">
        <div class="w-100">
          <p>Is Manager ?</p>
        </div>
        <div style="position: relative;" class="row">
          <div class="choose-window">
            <p>Off</p>
            <label class="switch">
              <input type="checkbox" name="readOnlyPermissions" [ngModel]="editAdmin?.readOnlyPermissions">
              <span class="slider round"></span>
            </label>
            <p>ON</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8 offset-lg-2 col-md-12 ">
          <div class="form-group ">
            <button type="submit" class="form-control btn btn-block btn-success" translate>customer.editAdmin</button>
          </div>
        </div>
      </div>
    </form>
    <div class="delete-customer" (click)="adminToDelete(dialogDeleteAdmin)" translate>customer.deleteAdmin</div>
  </div>
</ng-template>

<!-- Modal delete admin -->
<ng-template #dialogDeleteAdmin let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="modal-title" style="font-size: 16px">Are you sure you want to delete <span
        style="font-weight: bold;">{{editAdmin.name}}</span> ?</h3>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <button type="button" class="btn btn-outline-dark btn-yes" (click)="deleteAdmin()">YES</button>
    <button type="button" class="btn btn-outline-dark btn-no" (click)="c('No click')">NO</button>
  </div>
</ng-template>

<!-- ADD FEATURE PRICE -->
<app-modal (close)="toggleFeaturePrice = !toggleFeaturePrice" *ngIf="toggleFeaturePrice">
  <div class="modal_container black-text">
    <p class="text-header-modal">New Feature Price</p>

    <form #featureForm="ngForm" (ngSubmit)="addFeaturePrice(featureForm)" class="form-vehicle">

      <div class="form-group">
        <select class="form-control" name="featureId" ngModel>
          <option value="" disabled selected>Select Feature</option>
          <option *ngFor="let feature of features" value="{{feature.id}}">{{feature.displayName}}</option>
        </select>
      </div>

      <input placeholder="Price" type="number" name="price" ngModel class="form-control" required>

      <div style="min-height: 24px;"></div>

      <button type="submit" class="custom-button" style="width: 120px;">SAVE</button>

    </form>
  </div>
</app-modal>

<!-- EDIT FEATURE PRICE -->
<app-modal (close)="togglePrice = !togglePrice" *ngIf="togglePrice">
  <div class="modal_container black-text">
    <p class="text-header-modal">Edit Feature Price</p>

    <form #featureForm="ngForm" (ngSubmit)="editPrice(featureForm)" class="form-vehicle">

      <p>{{editFeaturePrice.displayName}}</p>

      <input placeholder="Price" type="number" name="price" [ngModel]="editFeaturePrice.price" class="form-control"
        required>

      <div style="min-height: 24px;"></div>

      <button type="submit" class="custom-button" style="width: 120px;">SAVE</button>

    </form>
  </div>
</app-modal>